export const formatTimestamp = (timestamp: number | Date | undefined): string => {
    if (!timestamp) return '-';
    try {
        const date = new Date(timestamp);
        return date.toLocaleString();
    } catch (error) {
        console.error('Timestamp 형식 변환 오류:', error);
        return '-';
    }
};
  
  export const formatAddress = (address: string): string => {
    if (!address || address.length < 10) return address;
    return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
  };